import axios from "axios";
import apiPath from "../constants/apiPath";

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: apiPath.baseURL,
});

// Add request interceptor to automatically include token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("session_id");
      // You might want to redirect to login here or show a message
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default apiClient;